import { render, staticRenderFns } from "./Createpwd.vue?vue&type=template&id=347df9e9&scoped=true"
import script from "./Createpwd.vue?vue&type=script&lang=js"
export * from "./Createpwd.vue?vue&type=script&lang=js"
import style0 from "./Createpwd.vue?vue&type=style&index=0&id=347df9e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347df9e9",
  null
  
)

export default component.exports